export default __webpack_public_path__ + "static/media/publicacion2.389e1b08.jpg";